import { defineNuxtPlugin, useRuntimeConfig } from '#imports';
import type { PostHog } from 'posthog-js';
import posthog from 'posthog-js';

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();
  const publicKey = runtimeConfig.public.posthog.publicKey;

  if (!publicKey) {
    return {
      provide: {
        posthog: undefined,
      },
    };
  }

  const posthogClient = posthog.init(publicKey, {
    api_host: runtimeConfig.public.posthog.host,
    defaults: runtimeConfig.public.posthog.posthogDefaults as any,
  });

  nuxtApp.hook('vue:error', (error) => {
    posthogClient?.captureException(error);
  });

  return {
    provide: {
      posthog: posthogClient as PostHog,
    },
  };
});
